import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	token: null,
	refreshToken: null,
	error: null,
	signed: false,
	status: null,
	loading: false,
};

const { actions, reducer } = createSlice({
	name: 'session',
	initialState,
	reducers: {
		login: (state) => state,
		loginSuccess: (state, { payload }) => ({
			...state,
			token: payload.token,
			refreshToken: payload.refreshToken,
			error: null,
			signed: true,
		}),
		loginFailure: (state, { payload }) => ({
			...state,
			error: payload,
			signed: false,
		}),
		logout: (state) => state,
		logoutSuccess: (state) => ({
			...state,
			token: null,
			refreshToken: null,
			//error: null,
			signed: false,
		}),
		logoutFailure: (state, { payload }) => ({
			...state,
			error: payload,
			//signed: true,
		}),
		setNewRefreshTokenSuccess: (state, { payload }) => ({
			...state,
			token: payload.token,
			refreshToken: payload.refreshToken,
			error: null,
			signed: true,
		}),
	},
});

export const {
	login,
	loginSuccess,
	loginFailure,
	logout,
	logoutFailure,
	logoutSuccess,
	setNewRefreshTokenSuccess,
} = actions;

export { default as sessionSaga } from './sagas';

export default reducer;
